import locales from '../locales';
import {OptionProps} from 'antd/lib/select';
import {ColumnFilterItem} from 'antd/es/table';

export const PaymentType = {
  TRANSFER: 'TRANSFER',
  CASH: 'CASH'
};

const paymentTypeToText = {
  [PaymentType.TRANSFER]: locales.paymentType_transfer,
  [PaymentType.CASH]: locales.paymentType_cash,
};

export function getPaymentTypeOptions(): OptionProps[] {
  return Object.keys(PaymentType)
    .map(type => ({value: type, key: type, title: paymentTypeToText[type]}));
}

export function getPaymentTypeLabel(paymentType?: string): string | undefined {
  return paymentType ? paymentTypeToText[paymentType] : undefined;
}

export function getPaymentTypeFilters(): ColumnFilterItem[] {
  return [PaymentType.TRANSFER, PaymentType.CASH]
    .map(type => ({text: paymentTypeToText[type], value: type}));
}


// WEBPACK FOOTER //
// ./src/common/PaymentType.tsx